
export const enum PostType {
    Post = 'Post',
    Gallery = 'Gallery',
    Story = 'Story',
}
